"use client";

import React from "react";
import Link from "next/link";
import OurButton from "../ourButton";

interface WebsiteSubtitleProps {
  text: string;
  title: string;
  tags?: string[];
  buttonHref?: string;
  textAlign?: "left" | "center";
}

export const WebsiteSubtitle: React.FC<WebsiteSubtitleProps> = ({
  text,
  title,
  tags = [],
  buttonHref,
  textAlign = "center",
}) => {
  const renderTextWithBreaks = () => {
    return text.split("\n").map((paragraph, index) => (
      <React.Fragment key={index}>
        {paragraph}
        {index < text.split("\n").length - 1 && <br />}
      </React.Fragment>
    ));
  };

  const textAlignmentClass = textAlign === "left" ? "text-left" : "text-center";

  return (
    <div className="w-[80%] flex flex-col gap-[100px] mx-auto">
      <p
        className={`${textAlignmentClass} text-[18px] pt-[25px] md:pt-0 md:text-[20px] w-full mx-auto leading-relaxed mt-4`}
        dangerouslySetInnerHTML={{ __html: text }}
      />

      <div className="flex flex-col justify-center items-center">
        <h3>{title}</h3>
        {tags.length > 0 && (
          <div className="flex justify-center items-center flex-wrap gap-2 md:gap-4 py-5">
            {tags.map((item) => (
              <a
                key={item}
                href={`#${item.toLowerCase().replace(/\s+/g, "-")}`}
                className="uppercase underline group flex justify-end items-center gap-2.5 self-stretch px-3 py-1 rounded-md hover:bg-blue-50 hover:text-blue-500 transition-colors duration-200"
              >
                {item}
              </a>
            ))}
          </div>
        )}
        {buttonHref && (
          <OurButton textForButton="Visit Website" href={buttonHref} />
        )}
      </div>
    </div>
  );
};